import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  faUsers,
  faCalendarCheck,
  faUserFriends,
  faClipboardList,
} from "@fortawesome/free-solid-svg-icons";

import { MetricsCompactCarousel } from "./MetricsCompactCarousel";

/**
 * Compact coach home metrics — horizontal snap strip (3 visible per snap).
 */
export const MetricsCoachHome = ({ data }) => {
  const { t } = useTranslation();

  const items = useMemo(
    () => [
      {
        key: "groups",
        icon: faUsers,
        label: t("coachMetricGroups"),
        value: data?.coachGroupsCount ?? 0,
        tone: "groups",
      },
      {
        key: "sessions",
        icon: faCalendarCheck,
        label: t("coachMetricSessionsDoneYear"),
        value: data?.sessionsFinalizedThisYear ?? 0,
        tone: "sessions",
      },
      {
        key: "players",
        icon: faUserFriends,
        label: t("coachMetricUniquePlayers"),
        value: data?.uniquePlayersPresent ?? 0,
        tone: "players",
      },
      {
        key: "upcoming",
        icon: faClipboardList,
        label: t("coachMetricScheduledUpcoming"),
        value: data?.sessionsScheduledUpcoming ?? 0,
        tone: "upcoming",
      },
    ],
    [data, t]
  );

  return <MetricsCompactCarousel items={items} />;
};
